function appDisplayContents() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./app-display-contents.html'),
    scope: {
      fields: '='
    }
  };
}

export { appDisplayContents };
